import React from 'react';
import { Bike, Bus, Car, Plane, Ship, Train, Truck } from 'lucide-react';

const MODE_ICONS = {
  car: Car,
  bus: Bus,
  train: Train,
  plane: Plane,
  boat: Ship,
  motorcycle: Bike,
  truck: Truck,
};

export function TransportModeIcon({ mode, ...props }) {
  const Icon = MODE_ICONS[mode] || Car;
  return <Icon {...props} />;
}
